import React, { Component } from "react"
import GoTrue from "gotrue-js"
import { connect } from "react-redux"
import { controlModal } from "../actions/index"
import { saveUser } from "../actions/index"
import { Link } from "react-router-dom"
// import FacebookLogin from "react-facebook-login"

const auth = new GoTrue({
  APIUrl: "https://english-for-libya.netlify.app/.netlify/identity",
  audience: "",
  setCookie: true,
})

class Register extends Component {
  state = {
    email: "",
    password: "",
    school: "",
    name: "",
    loginError: "",
    registerSuccess: "",
    registerError: "",
  }

  // callback when successfully logged in via facebook
  responseFacebook = (response) => {
    // check if user has email address, if not set Jessie's as placeholder
    if (response.email) {
      var emailValue = response.email
    } else {
      emailValue = "jessiecandy@garneteducation.com"
    }

    // save the user using the same structure as Netlify Identity
    this.props.saveUser({
      email: emailValue,
      image: response.picture.data.url,
      user_metadata: {
        full_name: response.name,
      },
    })

    // close modal window
    this.props.controlModal(false)
  }

  closeModal = () => {
    this.props.controlModal(false)
  }

  nameInput = (event) => {
    this.setState({ name: event.target.value })
  }

  emailInput = (event) => {
    this.setState({ email: event.target.value })
  }

  passwordInput = (event) => {
    this.setState({ password: event.target.value })
  }

  schoolInput = (event) => {
    this.setState({ school: event.target.value })
  }

  registerSubmit = (event) => {
    auth
      .signup(this.state.email, this.state.password, {
        full_name: this.state.name,
        school: this.state.school,
      })
      .then((response) =>
        this.setState({
          registerSuccess:
            "You have successfully registered. Before you can log in you need to click the link that has been emailed to you.",
        })
      )
      .catch((error) => this.setState({ registerError: error.json.msg }))

    event.preventDefault()
  }

  loginSubmit = (event) => {
    auth
      .login(this.state.email, this.state.password, true)
      //.then(response => console.log(auth.currentUser()))

      // call action which saves response to localStorage and then to redux store
      .then((response) => this.props.saveUser(response))
      .then((response) => this.props.controlModal(false))

      .catch((error) =>
        this.setState({ loginError: error.json.error_description })
      )

    event.preventDefault()
  }

  render() {
    return (
      <div>
        {this.props.modalMode === "login" ? (
          <div class="login-wrapper">
            {/*<div class="facebook-login">
              <h2 style={{ marginTop: 20, color: "#816992" }}>
                Log in with Facebook
              </h2>
              <FacebookLogin
                appId="796700704173797"
                autoLoad={false}
                fields="name,email,picture"
                callback={this.responseFacebook}
                cssClass="blue-button"
                icon="fa-facebook"
              />
        </div>*/}

            <div class="email-login">
              <h2 style={{ marginTop: 20, color: "#816992" }}>
                Log in with email
              </h2>
              <form onSubmit={this.loginSubmit}>
                <label>Email</label>
                <input
                  placeholder="Email address"
                  type="text"
                  value={this.state.email}
                  onChange={this.emailInput}
                ></input>
                <br />

                <label>Password</label>

                <input
                  type="password"
                  placeholder="Password"
                  value={this.state.password}
                  onChange={this.passwordInput}
                ></input>
                <br />
                <p>
                  Forgotten your password?{" "}
                  <Link to="/password-reset" onClick={() => this.closeModal()}>
                    Reset it here.
                  </Link>
                </p>

                <input
                  style={{ marginTop: 20 }}
                  className="purple-button"
                  type="submit"
                  value="Submit"
                />
              </form>
            </div>

            {this.state.loginError.length ? (
              <p className="auth-error">{this.state.loginError}</p>
            ) : (
              <p></p>
            )}
          </div>
        ) : (
          <div style={{ marginTop: 40 }}>
            <h2 style={{ marginTop: 20, color: "#816992" }}>Register</h2>
            {/*<p
              style={{
                maxWidth: "80%",
                margin: "auto",
                paddingBottom: "10px",
                color: "#816992",
              }}
            >
              You only need to register if you want to log in using your email
              address. If you prefer to log in using Facebook there is no need
              to register.
            </p>*/}
            <form onSubmit={this.registerSubmit}>
              <label>Name</label>
              <input
                placeholder="Full name"
                type="text"
                value={this.state.name}
                onChange={this.nameInput}
              ></input>
              <br />

              <label>Email</label>
              <input
                placeholder="Email address"
                type="text"
                value={this.state.email}
                onChange={this.emailInput}
              ></input>
              <br />

              <label>Password</label>
              <input
                type="password"
                placeholder="Password"
                value={this.state.password}
                onChange={this.passwordInput}
              ></input>
              <br />

              <label>School</label>
              <input
                type="text"
                placeholder="School"
                value={this.state.school}
                onChange={this.schoolInput}
              ></input>
              <br />

              <input
                style={{ marginTop: 20 }}
                className="purple-button"
                type="submit"
                value="Submit"
              />
            </form>

            {this.state.registerError.length ? (
              <p className="auth-error">{this.state.registerError}</p>
            ) : (
              <p></p>
            )}

            {this.state.registerSuccess.length ? (
              <p className="auth-success">{this.state.registerSuccess}</p>
            ) : (
              <p></p>
            )}
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    // updateUser: (user) => dispatch(updateUser(user)),
    controlModal: (bool) => dispatch(controlModal(bool)),
    saveUser: (user) => dispatch(saveUser(user)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Register)



// WEBPACK FOOTER //
// ./src/components/Register.js